import React, { useContext } from 'react';
import { Card, CardHeader, CardBody } from '@progress/kendo-react-layout';
import { ITicketProps } from '../../../../types/Ticket/ITicket';
import Toolbar from './Toolbar';
import AutoStatusBanner from './AutoStatusBanner';
import AutoLinker from './Tools/AutoLinker';
import { Skeleton } from '@progress/kendo-react-indicators';
import FlaggedNotes from '../../FormControls/FlaggedNotes/FlaggedNotes';
import { RevUserContext } from '../../../../context/UserContext';
import { IUserProfile } from '../../../../types/User/IUserProfile';

const TicketHeader: React.FC<ITicketProps> = (details) => {
    const profile = useContext<IUserProfile>(RevUserContext)
    return (
        <Card>
            <CardHeader className='main-header d-flex'>
                <Toolbar  {...details} />
            </CardHeader>
            <CardBody className='p-0'>
                {details?.Is_Loading ?
                    <>
                        {/* <Skeleton shape="rectangle" style={{ width: '100%', height: '100px', marginTop: '10px' }} /> */}
                        <h6 className='description'>...</h6></>
                    : <>
                        <h6 className='description'><AutoLinker text={details?.Call_Desc?.replaceAll('\n', '<br>')} /></h6>
                        <AutoStatusBanner ticket={details} />
                        {!profile?.Features.External_Interface && <FlaggedNotes ticket={details} showPopup={false} showNotes={true} />}
                    </>
                }
            </CardBody>
        </Card>
    );
};

export default TicketHeader;